// extracted by mini-css-extract-plugin
export default {"container":"BillingLabelValue_container__rl6XG","label":"BillingLabelValue_label__2z4Pb","value":"BillingLabelValue_value__bRIhE","large":"BillingLabelValue_large__bFqea"};